import { render, staticRenderFns } from "./ListTotalChargesV2.vue?vue&type=template&id=2dcdb4b8&scoped=true&"
import script from "./ListTotalChargesV2.vue?vue&type=script&lang=js&"
export * from "./ListTotalChargesV2.vue?vue&type=script&lang=js&"
import style0 from "./ListTotalChargesV2.vue?vue&type=style&index=0&id=2dcdb4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdb4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VTextField,
})
